import { createContext, useContext } from "react";

import { getResponseModel } from "../models/ResponseModel";
import { serverMain } from "../settings/serverConfig";
import { useLayout } from "./LayoutContext";
import { useToken } from "./TokenContext";

export const RequestContext = createContext();

export function RequestProvider(props) {
    const { appKey, appToken } = useToken();
    const { handleOpenAlert, handleLoader } = useLayout();

    const errorMessage = "Ocurrió un error al consumir el recurso solicitado";
    const errorService = "Ocurrió un error en el servicio solicitado. Intente más tarde";

    const Get = async (payload) => {
        let response = getResponseModel();
        if (payload.loader) {
            handleLoader(payload.loader);
        }
        try {
            const api = await fetch(serverMain + payload.url, {
                headers: {
                    AppKey: appKey,
                    AppToken: appToken,
                },
            });
            response = await api.json();
            if (payload.alert) {
                if (response.Code === 0) {
                    handleOpenAlert(response.Message, "success");
                } else {
                    handleOpenAlert(response.Message);
                }
            }
        } catch (error) {
            response.Code = -1;
            response.Message = errorMessage;
            //   if (payload.alert) {
            //     handleOpenAlert(response.Message);
            //   }
            handleOpenAlert(response.Message);
        }
        handleLoader();
        return response;
    };

    const GetFile = async (payload) => {
        let response = getResponseModel();
        if (payload.loader) {
            handleLoader(payload.loader);
        }
        try {
            const api = await fetch(serverMain + payload.url, {
                headers: {
                    AppKey: appKey,
                    AppToken: appToken,
                },
            });
            if (api.ok) {
                let file = await api.blob();
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(file);
                link.download = payload.filename;
                link.click();
                link.remove();
                response.Message = "El archivo se ha descargado correctamente.";
                if (payload.alert) {
                    handleOpenAlert(response.Message, "success");
                }
            } else {
                response.Code = -1;
                response.Message = errorService;
                // if (payload.alert) {
                //     handleOpenAlert(response.Message);
                // }
                handleOpenAlert(response.Message);
            }
        } catch (error) {
            response.Code = -1;
            response.Message = errorMessage;
            // if (payload.alert) {
            //     handleOpenAlert(response.Message);
            // }
            handleOpenAlert(response.Message);
        }
        handleLoader();
        return response;
    };

    const Post = async (payload) => {
        let response = getResponseModel();
        if (payload.loader) {
            handleLoader(payload.loader);
        }
        try {
            const api = await fetch(serverMain + payload.url, {
                method: "POST",
                body: JSON.stringify(payload.body),
                headers: {
                    "Content-Type": "application/json",
                    AppKey: appKey,
                    AppToken: appToken,
                },
            });
            response = await api.json();
            if (payload.alert) {
                if (response.Code === 0) {
                    handleOpenAlert(response.Message, "success");
                } else {
                    handleOpenAlert(response.Message);
                }
            }
        } catch (error) {
            response.Code = -1;
            response.Message = errorMessage;
            // if (payload.alert) {
            //     handleOpenAlert(response.Message);
            // }
            handleOpenAlert(response.Message);
        }
        handleLoader();
        return response;
    };

    const PostFile = async (payload) => {
        let response = getResponseModel();
        if (payload.loader) {
            handleLoader(payload.loader);
        }
        try {
            const api = await fetch(serverMain + payload.url, {
                method: "POST",
                body: payload.file,
                headers: {
                    "Content-Type": "application/json",
                    AppKey: appKey,
                    AppToken: appToken,
                },
            });
            response = await api.json();
            if (payload.alert) {
                if (response.Code === 0) {
                    handleOpenAlert(response.Message, "success");
                } else {
                    handleOpenAlert(response.Message);
                }
            }
        } catch (error) {
            response.Code = -1;
            response.Message = errorMessage;
            // if (payload.alert) {
            //     handleOpenAlert(response.Message);
            // }
            handleOpenAlert(response.Message);
        }
        handleLoader();
        return response;
    };

    const PostFormData = async (payload) => {
        let response = getResponseModel();
        if (payload.loader) {
            handleLoader(payload.loader);
        }
        try {
            const api = await fetch(serverMain + payload.url, {
                method: "POST",
                body: payload.body,
                headers: {
                    AppKey: appKey,
                    AppToken: appToken,
                },
            });
            response = await api.json();
            if (payload.alert) {
                if (response.Code === 0) {
                    handleOpenAlert(response.Message, "success");
                } else {
                    handleOpenAlert(response.Message);
                }
            }
        } catch (error) {
            response.Code = -1;
            response.Message = errorMessage;
            if (payload.alert) {
                handleOpenAlert(response.Message);
            }
        }
        handleLoader();
        return response;
    };

    return (
        <RequestContext.Provider value={{ Get, GetFile, Post, PostFile, PostFormData }}>
            {props.children}
        </RequestContext.Provider>
    );
}

export function useRequest() {
    return useContext(RequestContext);
}
